import { NavLink } from 'react-router-dom';
import './TabBar.css';

/**
 * Bottom tab bar — Home / Designs / Lessons / You.
 * Used on every authenticated screen. Hidden on /signin.
 *
 * Note: the "Designs" tab still routes to /plans for now — only the label
 * changed. If we rename the route later, update App.tsx routing, any
 * internal links, and the Netlify _redirects.
 */
export default function TabBar() {
  return (
    <nav className="tab-bar" aria-label="Primary">
      <NavLink to="/" end className="tab">
        <IconHome />
        <span>Home</span>
      </NavLink>
      <NavLink to="/plans" className="tab">
        <IconDesigns />
        <span>Designs</span>
      </NavLink>
      <NavLink to="/lessons" className="tab">
        <IconLessons />
        <span>Lessons</span>
      </NavLink>
      <NavLink to="/you" className="tab">
        <IconYou />
        <span>You</span>
      </NavLink>
    </nav>
  );
}

/* ─── Inline SVG icons (no external icon dependency) ───
   Each icon has its own brand colour so the bar reads as a colourful set
   rather than a monochrome strip. Sizes bumped from 20→24px so the icons
   carry more visual weight relative to the labels.

   Colours pulled from the established brand palette:
     - Home    → forest  #3a8a63 (primary brand)
     - Designs → terra   #c45c3a (warm/creative)
     - Lessons → sky     #4a9fd9 (learning/clarity)
     - You     → plum    #a05ec1 (identity)
*/

function IconHome() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#3a8a63" strokeWidth="1.7" aria-hidden="true">
      <path d="M3 11l9-7 9 7v9a1 1 0 0 1-1 1h-5v-7H9v7H4a1 1 0 0 1-1-1z" />
    </svg>
  );
}
function IconDesigns() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#c45c3a" strokeWidth="1.7" aria-hidden="true">
      <rect x="4" y="6" width="16" height="3" rx="1" />
      <rect x="4" y="11" width="16" height="3" rx="1" />
      <rect x="4" y="16" width="16" height="3" rx="1" />
    </svg>
  );
}
function IconLessons() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#4a9fd9" strokeWidth="1.7" aria-hidden="true">
      <path d="M4 5a2 2 0 0 1 2-2h12v18H6a2 2 0 0 1-2-2z" />
      <path d="M8 7h8M8 11h8M8 15h5" />
    </svg>
  );
}
function IconYou() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#a05ec1" strokeWidth="1.7" aria-hidden="true">
      <circle cx="12" cy="8" r="4" />
      <path d="M4 21c0-4 4-7 8-7s8 3 8 7" />
    </svg>
  );
}
